import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './FreeSpinLauncher.css';

export default function FreeSpinLauncher({ visible = true, label = 'Free Spin', isLoggedIn = false }) {
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(false);
  const [showMsg, setShowMsg] = useState(false);

  if (!visible || hidden) return null;

  return (
    <>
      <button
        aria-label="Open Free Spin"
        className="fs-float-launcher"
        onClick={() => {
          if (isLoggedIn) {
            navigate('/free-spin');
          } else {
            setShowMsg(true);
          }
        }}
      >
        <img
          className="fs-float-logo"
          src={`${process.env.PUBLIC_URL}/poster/freespin.gif`}
          alt="Free Spin"
        />
        <span
          className="fs-float-close"
          role="button"
          aria-label="Close launcher"
          onClick={(e) => { e.stopPropagation(); setHidden(true); }}
        >
          ×
        </span>
      </button>

      {showMsg && (
        <div className="fs-login-msg" role="dialog" aria-live="polite">
          <div className="fs-login-msg-inner">
            <div className="fs-login-msg-title">Free Spin</div>
            <div className="fs-login-msg-body">
              Please login or sign up to use Free Spin and make a deposit.
            </div>
            <div className="fs-login-actions">
              <button className="fs-login-btn" onClick={() => navigate('/login')}>Login</button>
              <button className="fs-signup-btn" onClick={() => navigate('/signup')}>Sign Up</button>
              <button className="fs-msg-close" onClick={() => setShowMsg(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
